export const expensesCostLineDefaultValues = {
  application_id: "",
  cost_type: null,
  currency_code: null,
  internal_order_id: "",
  amount: null,
  name: "null",
  description: "",
  purchase_date: null,
  payment_method_type: "",
  vat: null,
  attachments: null,
  distance: null,
  vehicle_id: null,
  expense_document_type: null,
  accommodation_required_line: false,
  company_card_payment: false,
  sap_vendor_number: "",
  invoice_number: "",
  is_job_related: false,
};
